module.exports = __webpack_public_path__ + "static/20230619_158-3b81673380caac0b3431304e087d57b2.jpg";